export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'CA',
  'merchantReturnLink': 'https://timberland.ca/fr-ca/customer-care/returns/free-return-policy',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
